import React from 'react';
import { Link } from 'react-router-dom';
import './CTASection.css';

interface CTAAction {
  label: string;
  to: string;
  variant?: 'primary' | 'secondary';
}

interface CTASectionProps {
  title: string;
  description: string;
  actions: CTAAction[];
}

const CTASection: React.FC<CTASectionProps> = ({ title, description, actions }) => {
  return (
    <section className="consulting-cta">
      <div className="container">
        <h2 className="cta-title">{title}</h2>
        <p className="cta-description">{description}</p>
        <div className="cta-actions">
          {actions.map((action, index) => (
            <Link key={index} to={action.to}>
              <button className={`btn-${action.variant || 'primary'} btn-large`}>
                {action.label}
              </button>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTASection;

